import createStore from "./core";
import storeMaps from "./storeMaps";

const store = createStore(storeMaps);
const { useStore, Provider } = store;

export default store;
export { useStore, Provider };
